import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = {
  class: "card-body p-4",
  style: {"padding-bottom":"0 !important"}
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-xxl-6 col-xl-6 col-sm-6" }
const _hoisted_5 = { class: "card bg-primary bg-opacity-10 border-primary-div border-opacity-10 rounded-3 mb-4 stats-box style-three" }
const _hoisted_6 = { class: "card-body p-4" }
const _hoisted_7 = { class: "d-flex align-items-center mb-19" }
const _hoisted_8 = { class: "flex-grow-1 ms-2" }
const _hoisted_9 = { class: "fs-20 mt-1 mb-0" }
const _hoisted_10 = { class: "col-xxl-6 col-xl-6 col-sm-6" }
const _hoisted_11 = { class: "card bg-danger bg-opacity-10 border-danger border-opacity-10 rounded-3 mb-4 stats-box style-three" }
const _hoisted_12 = { class: "card-body p-4" }
const _hoisted_13 = { class: "d-flex align-items-center mb-19" }
const _hoisted_14 = { class: "flex-grow-1 ms-2" }
const _hoisted_15 = { class: "fs-20 mt-1 mb-0" }
const _hoisted_16 = { class: "col-xxl-6 col-xl-6 col-sm-6" }
const _hoisted_17 = { class: "card bg-primary-div bg-opacity-10 border-primary-div border-opacity-10 rounded-3 mb-4 stats-box style-three" }
const _hoisted_18 = { class: "card-body p-4" }
const _hoisted_19 = { class: "d-flex align-items-center mb-19" }
const _hoisted_20 = { class: "flex-grow-1 ms-2" }
const _hoisted_21 = { class: "fs-20 mt-1 mb-0" }
const _hoisted_22 = { class: "col-xxl-6 col-xl-6 col-sm-6" }
const _hoisted_23 = { class: "card bg-success bg-opacity-10 border-success border-opacity-10 rounded-3 mb-4 stats-box style-three" }
const _hoisted_24 = { class: "card-body p-4" }
const _hoisted_25 = { class: "d-flex align-items-center mb-19" }
const _hoisted_26 = { class: "flex-grow-1 ms-2" }
const _hoisted_27 = { class: "fs-20 mt-1 mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "mb-3 mb-lg-4" }, [
        _createElementVNode("h3", { class: "mb-0" }, "Requisition Overview")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined fs-40 text-primary" }, " draft ")
                ], -1)),
                _createElementVNode("div", _hoisted_8, [
                  _cache[0] || (_cache[0] = _createElementVNode("span", null, "Draft", -1)),
                  _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.reqOverview?.draft), 1)
                ])
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "d-flex justify-content-between flex-wrap gap-2 align-items-center" }, [
                _createElementVNode("span", { class: "fs-12" }, "Requisition Status Draft")
              ], -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined fs-40 text-danger" }, " hourglass_bottom ")
                ], -1)),
                _createElementVNode("div", _hoisted_14, [
                  _cache[3] || (_cache[3] = _createElementVNode("span", null, "Waiting Approval", -1)),
                  _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.reqOverview?.waiting), 1)
                ])
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "d-flex justify-content-between flex-wrap gap-2 align-items-center" }, [
                _createElementVNode("span", { class: "fs-12" }, "Requisition Status Waiting Approval")
              ], -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined fs-40 text-primary-div" }, " edit_square ")
                ], -1)),
                _createElementVNode("div", _hoisted_20, [
                  _cache[6] || (_cache[6] = _createElementVNode("span", null, "On Process", -1)),
                  _createElementVNode("h3", _hoisted_21, _toDisplayString(_ctx.reqOverview?.process), 1)
                ])
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "d-flex justify-content-between flex-wrap gap-2 align-items-center" }, [
                _createElementVNode("span", { class: "fs-12" }, "Requisition Status On Process")
              ], -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined fs-40 text-success" }, " assignment_turned_in ")
                ], -1)),
                _createElementVNode("div", _hoisted_26, [
                  _cache[9] || (_cache[9] = _createElementVNode("span", null, "Complete", -1)),
                  _createElementVNode("h3", _hoisted_27, _toDisplayString(_ctx.reqOverview?.completed), 1)
                ])
              ]),
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "d-flex justify-content-between flex-wrap gap-2 align-items-center" }, [
                _createElementVNode("span", { class: "fs-12" }, "Requisition Status Completed")
              ], -1))
            ])
          ])
        ])
      ])
    ])
  ]))
}